import { render, staticRenderFns } from "./dispose.vue?vue&type=template&id=7bdeaf9d"
import script from "./dispose.vue?vue&type=script&lang=js"
export * from "./dispose.vue?vue&type=script&lang=js"
import style0 from "./dispose.vue?vue&type=style&index=0&id=7bdeaf9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports